import { APCalculatorBase } from '../../../components/tools/APCalculatorBase';


const frqQuestions = [
  {
    name: "Experimental Design",
    maxScore: 12,
    weight: 0.125,
    description: "Design and describe an experimental investigation"
  },
  {
    name: "Quantitative/Qualitative Translation",
    maxScore: 12,
    weight: 0.125,
    description: "Translate between mathematical and verbal descriptions"
  },
  {
    name: "Paragraph Argument",
    maxScore: 7,
    weight: 0.125,
    description: "Construct scientific explanations"
  },
  {
    name: "Short Answer",
    maxScore: 7,
    weight: 0.125,
    description: "Analyze experimental data and observations"
  }
];

const apPhysics1Config = {
  title: "AP Physics 1 Score Calculator",
  description: "Calculate your AP Physics 1 exam score instantly with our comprehensive calculator. Updated for 2025 AP Physics 1 exam format with detailed scoring guidelines.",
  keywords: [
    "AP Physics 1 score calculator",
    "AP Physics 1 calculator",
    "AP Physics 1 score estimation",
    "2025 AP Physics 1 scoring",
    "AP Physics algebra calculator",
    "AP Physics 1 FRQ scoring"
  ],
  mcqTotal: 50,
  frqQuestions,
  mcqWeight: 0.5,
  frqWeight: 0.5,
  path: "/tools/ap-physics-1-score-calculator",
  examSpecificInfo: {
    fullName: "AP Physics 1: Algebra-Based",
    examFormat: "Multiple choice (50 questions, 90 minutes) and free response (5 questions, 90 minutes)",
    passingRate: "Approximately 43% of students score 3 or higher",
    collegeCredit: "Many colleges offer credit for scores of 3 or higher"
  }
};

export function APPhysics1Calculator() {
  return <APCalculatorBase config={apPhysics1Config} />;
}